import React from 'react';
import propTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { saveAs } from 'file-saver';
import axios from 'axios';

/**
 * Download Component
 * @param {*} props 
 */
function Download(props){
  let [download, setDownload] = React.useState(false);

  const DownloadFile = React.useCallback(async() => {
    try{
      setDownload(true);

      if(props.action === 'download'){
        const File = await axios.get(`https://rrapidocuments.azurewebsites.net/documents/downloadFile/${props.file}`);
        const linkSource = `data:application/${props.type};base64,${File.data.data}`;
        saveAs(linkSource, `${props.name}.${props.type}`);
      } else if (props.action === 'visualization'){
        setDownload(false);
        window.open(`https://fsposeidon.blob.core.windows.net/magicrrvision/${props.file}`);
      } 
      setDownload(false);
    }catch(error){
      console.error('the error ==>', error);
      setDownload(false);
    }
  }, [props]);

  return (
    <Button style={{ color: '#005e97' }} disabled={download} onClick={DownloadFile}>
      {
        props.action === 'download' ? 
        <i className={ download ? `big spinner loading icon`: `fas fa-download fa-2x dataIcon`}/>:
        <i className={ download ? `big spinner loading icon`: `fas fa-search fa-2x`}/>
        
      }
    </Button>
  );
}

Download.propTypes = {
  action: propTypes.string,
  name: propTypes.string,
  file: propTypes.string
};

Download.defaultProps = {
  action: '',
  name: '',
  file: '',

};

export default Download;